import { createAction } from '@reduxjs/toolkit';

export const modifyNotificationSetting = createAction(
  'notificationSettings/modifyNotificationSetting'
);
